<template>
  <div class="notification-header">
    <div class="notification-actions">
      <span class="notification-title">{{ $t("Notification.name") }}</span>
      <div class="notification-filters">
        <button
          class="filter-button"
          :class="{ active: !showUnreadOnly }"
          @click="toggleUnreadFilter(false)"
        >
          All
        </button>
        <button
          class="filter-button unread-button"
          :class="{ active: showUnreadOnly }"
          @click="toggleUnreadFilter(true)"
        >
          Unread
          <span v-if="unreadCount" class="unread-badge">{{ unreadCount }}</span>
        </button>
      </div>
    </div>
    <div class="action-container">
      <button @click="viewAll" class="action-button read-all">
        <span class="material-symbols-outlined">done_all</span>
        <span class="button-text">{{ $t("Notification.readAll") }}</span>
      </button>
      <button @click="deleteAll" class="action-button delete-all">
        <span class="material-symbols-outlined">delete_forever</span>
        <span class="button-text">{{ $t("Notification.deleteAll") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationHeader",
  props: {
    unreadCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showUnreadOnly: false,
    };
  },
  methods: {
    viewAll() {
      this.$emit("view-all");
    },
    deleteAll() {
      this.$emit("delete-all");
    },
    toggleUnreadFilter(value) {
      this.showUnreadOnly = value;
      this.$emit("toggle-unread", value);
    },
  },
};
</script>

<style scoped>
.action-container {
  display: flex;
  gap: 12px;
  background: #f8f9fa;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.action-button {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: none;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  color: #2c3e50;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.action-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.read-all {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
}

.delete-all {
  background: linear-gradient(135deg, #ef5350, #e53935);
  color: white;
}

.material-symbols-outlined {
  font-size: 18px;
  vertical-align: middle;
}

.button-text {
  white-space: nowrap;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.notification-actions {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.notification-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.notification-filters {
  display: flex;
  gap: 0.5rem;
}

.filter-button {
  padding: 8px 19px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 500;
  background: transparent;
  color: #6b7280;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-button:hover {
  background: #f3f4f6;
}

.filter-button.active {
  background: #f3f4f6;
  color: #1f2937;
  border-color: #d1d5db;
}

.unread-button {
  position: relative;
}

.unread-badge {
  background: #ef4444;
  color: white;
  font-size: 10px;
  padding: 0.125rem 0.375rem;
  border-radius: 9999px;
  font-weight: 600;
}
.view-all-button:hover {
  background: var(--logo-hover-color);
}

@media (max-width: 768px) {
  .notification-header {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    padding: 0;
    border-bottom: none;
    margin-bottom: 8px;
  }

  .notification-actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  .view-all-button {
    width: 100%;
    justify-content: center;
  }

  .action-container {
    display: flex;
    justify-content: space-between;
  }

  .action-button{
    gap: 0px;
    font-size: 10px;
    min-height: 30px;
  }

  .material-symbols-outlined {
    font-size: 11px;
  }

  .notification-title {
    font-size: 1rem;
  }
  
  .filter-button {
    font-size: 11px;
    padding: 6px 17px;
  }
}
</style>
